import React, { FC } from 'react';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useSrriOverviewPageQuery } from '../../../../api/rs-hg/risk/hooks/queries';
import type { SrriOverviewTable } from '../../../../api/rs-hg/risk/srriOverview.types';
import FirstLevelTable from './srriShareClassOverviewComponents/FirstLevelTable.component';

const SrriShareClassOverview: FC<GeneralOverviewPageRenderedComponentProps> = ({
  positionDate,
  section,
  pageId,
}) => {
  const srriOverviewQuery = useSrriOverviewPageQuery(positionDate ?? '');
  const table = srriOverviewQuery.data?.data;

  return (
    <QueryBoundary<SrriOverviewTable>
      isLoading={srriOverviewQuery.isLoading}
      isFetching={srriOverviewQuery.isFetching}
      isError={srriOverviewQuery.isError}
      error={srriOverviewQuery.error}
      data={(table?.length ?? 0) > 1 ? table : null}
      loadingMessages={['Loading SRRI Share Class Overview...']}
      errorMessage="Unable to load SRRI share class overview data."
      noDataMessage="No SRRI share class overview data available."
    >
      {(rows) => (
        <FirstLevelTable rows={rows} section={section} pageId={pageId} />
      )}
    </QueryBoundary>
  );
};

export default SrriShareClassOverview;
